Cobalt.PageBlock = function (settings, guid) 
{
    this.guid = Cobalt.PageBlock.counter++;
    this.blockID = settings.blockID;
    this.placementID = settings.placementID;
    this.region = settings.region;
    this.element = settings.element;
    this.element.data("page-block", this);    
};

Cobalt.PageBlock.counter = 0;

Cobalt.PageBlock.prototype =
{
    blockID: null,
    placementID: null,
    config: null,
    guid: null, // The clientside GUID of this block.
    region: null, // A pointer back to the parent region (JS Class).
    element: null, // The HTML element representing this block,
    remove: function () {
        this.region.removeBlock(this);
    },
    undelete: function () {
        this.region.undeleteBlock(this);
    },
    moveTo: function (newRegion) {
        this.region.moveBlock(this, newRegion);
    },
    getDisplayOrder: function () {
        return this.element.prevAll().length;
    },
    saveDelete: function () {
        var url = "/cp/page-structure/" + this.region.structureID + "/delete-block?placementID=" + this.placementID;
        var that = this;
        
        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
            $.ajax(
                {
                    url: url,
                    type: "POST",
                    data: { 'request-verification-token': token },
                    success: function (data) {

                    }
                });
        });
    },
    saveUndelete: function () {
        var url = "/cp/page-structure/" + this.region.structureID + "/undelete-block?placementID=" + this.placementID;
        var that = this;
        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
            $.ajax(
                {
                    url: url,
                    type: "POST",
                    data: { 'request-verification-token': token },
                    success: function (data) {

                    }
                });
        });
    },
    savePlacement: function (configureAfterSave) {
        var url = "/cp/page-structure/" + this.region.structureID + "/place-block?blockID=" + this.blockID + "&pageRegionSlug=" + this.region.slug + "&displayOrder=" + this.getDisplayOrder() + (this.placementID != null ? "&placementID=" + this.placementID : "");
        var that = this;
        this.element.toggleClass("saving");
        Cobalt.Utils.getRequestVerificationToken().done(function (token) {
            $.ajax(
                {
                    url: url,
                    type: "POST",
                    data: { 'request-verification-token': token },
                    success: function (data) {
                        setTimeout(function () {
                            that.element.toggleClass("saving");
                        }, 500);
                        that.placementID = data.placementID;
                        if (configureAfterSave) {
                            that.configure();
                        }
                    }
                });
        });
    },
    configure: function () {

        var that = this;
        $.get(this.configurationURL(), function (data) {
            that.createConfigureModal(data.html);

        });
    },
    configurationURL: function () {
        var url = "/cp/page-structure/" + this.region.structureID + "/configure-block?blockID=" + this.blockID + (this.placementID != null ? "&placementID=" + this.placementID : "");
        return url;
    },
    createConfigureModal: function (html) {

        var that = this;
        var $editDiv = $('<div>');
        var closeOnSave = false;

        $editDiv.dialog({
            modal: true,
            dialogClass: "modal category-modal",
            draggable: false,
            title: "Configure Page Block",
            resizable: false,
            beforeclose: function () {
                Cobalt.TinyMCE.unload();
            },
            close: function (event, ui) {
                $(event.target).dialog("destroy");
                $(event.target).remove();
            }
        });

        $editDiv.parent().center({ sizeToWindow: true, maxWidth: 640, maxHeight: 510, minHeight: 540 });
        $editDiv.dialog("open");
        $editDiv.mask();

        var content = $(html);
        $editDiv.append(content);
        $editDiv.find("form#form-page-block").ajaxForm(
        {
            type: "POST",
            dataType: "json",
            beforeSubmit: function () {
                $editDiv.parent().mask();
            },
            success: function (result) {
                if (!result.Success) {
                    $editDiv.dialog("close");
                    that.createConfigureModal(result.html);
                }
                else if (closeOnSave) {
                    $editDiv.dialog("close");
                }
                else {
                    setTimeout(function () { $editDiv.parent().unmask() }, 250);
                }

                return false;
            }
        });

        Cobalt.triggerHtmlInsert($editDiv);
        $editDiv.find(".j-save-and-close-button").click(function () {
            closeOnSave = true;
        });

        $editDiv.unmask();

        // find any errors
        var errorFields = $editDiv.find(".field-errors");

        if (errorFields.length > 0) {
            var $firstErrorField = $(errorFields[0]);
            var erroredTabID = $firstErrorField.parents("div.tab-content-item").attr("data-tab-id");
            var erroredTabItem = $firstErrorField.parents("form").find("ul.tabbed-tabs").find("li[data-tab-id=" + erroredTabID + "]>a");
            erroredTabItem.trigger('click');
        }
    }
};


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.PageBlock.js